<template>
  <li class="category-tile">
    <NuxtLinkLocale
      :to="`/category/${category.slug}/${category.uuid}`"
      class="category-tile__link"
      :title="props.category.name"
    >
      <figure class="category-tile__content">
        <BaseImage
          class="category-tile__img"
          width="44"
          height="44"
          size="100x100"
          :name="props.category.image"
          :alt="props.category.name"
          default-category
        />
        <figcaption class="category-tile__title">
          {{ props.category.name }}
        </figcaption>
      </figure>
    </NuxtLinkLocale>
  </li>
</template>

<script lang="ts" setup>
import type { CategoryItemParent, FilterCategory } from '~/types/catalog'

type Props = {
  category: CategoryItemParent | FilterCategory
}
const props = defineProps<Props>()

</script>

<style lang="scss">
.category-tile {
  padding: 0;
  min-width: 13rem;

  &__link {
    text-decoration: none;
    color: $font-color;
    line-height: 1.8rem;
    @media only screen and (min-width: 740px) {
      font-size: 1.6rem;
      line-height: 2.2rem;
    }
  }

  &__content {
    width: 100%;
    height: 100%;
    padding: 1.2rem;
    background: #ffffff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    transition: box-shadow $transition-time;

    &:hover {
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    }

    @media only screen and (max-width: 740px) {
      //min-height: 11.28rem;
      text-align: center;
    }

    @media only screen and (min-width: 740px) {
      padding: 1.6rem 1.4rem;
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
      align-items: flex-start;
    }
  }

  &__img {
    object-fit: contain;
    flex-shrink: 0;
  }

  &__title {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    @media only screen and (min-width: 740px) {
      padding-right: 1rem;
    }
  }

  &__count {
    font-size: 1.2rem;
    line-height: 1.8rem;
    color: #737373;
  }
}
</style>
